import { PropsFilter } from "../../models/api/props-filter/props-filter";
import { SaveResponse } from "../../models/api/save/save.response";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentTypeDTO, DocumentTypeSTO } from "../../models/document-types";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class DocumentTypesApiService extends BaseApiService<DocumentTypeDTO, DocumentTypeSTO> {
  constructor() {
    super({
      servicePath: "/DocumentTypes",
      loadItemsPath: "/GetDocumentTypes",
      saveItemsPath: "/SaveDocumentTypes",
    });
    this.defaultSort = [
      {
        name: "sequence",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadDocumentType = async (id?: string) => {
  const response = await new DocumentTypesApiService().loadItems({
    requiredTransactionTypes: [id as string],
  } as PropsFilter);

  toastifyResponse(response, "failed");

  return response;
};

export const saveDocumentType = async (documentType: DocumentTypeSTO): Promise<SaveResponse> => {
  const response = await new DocumentTypesApiService().saveItems([documentType]);

  toastifyResponse(response);

  return response;
};
